import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { GetPerformanceQuery, PerformanceFormFillsDataResponse } from '../types';
import { usePerformanceFormFillsRequest } from './usePerformanceRequests';

const useGetFormFillCloseRate = (query?: GetPerformanceQuery) => {
    const [processedData, setProcessedData] =
        React.useState<PerformanceFormFillsDataResponse['cohort_reports']>();
    const { data } = usePerformanceFormFillsRequest(query);

    const [searchParams] = useSearchParams();
    const state = searchParams.get('state');

    React.useEffect(() => {
        if (!data) return;

        const filteredData = state
            ? data.cohort_reports.filter((item) => state.split(',').includes(item.state))
            : data.cohort_reports;

        const calculatedData = filteredData.reduce((acc, row) => {
            const existingWeek = acc.find(
                (item: PerformanceFormFillsDataResponse['cohort_reports'][number]) =>
                    item.week_start === row.week_start
            );

            if (existingWeek) {
                existingWeek.open_form_fills += row.open_form_fills;
                existingWeek.enrolled_form_fills += row.enrolled_form_fills;
                existingWeek.rejected_form_fills += row.rejected_form_fills;
                existingWeek.expired_form_fills += row.expired_form_fills;
                existingWeek.new_form_fills += row.new_form_fills;
            } else {
                acc.push({
                    state: '',
                    week_start: row.week_start,
                    week_end: row.week_end,

                    open_form_fills: row.open_form_fills,
                    enrolled_form_fills: row.enrolled_form_fills,
                    rejected_form_fills: row.rejected_form_fills,
                    expired_form_fills: row.expired_form_fills,
                    new_form_fills: row.new_form_fills,

                    conversion_rate: -1,
                    expiration_rate: -1
                });
            }

            return acc;
        }, [] as PerformanceFormFillsDataResponse['cohort_reports']);

        // Calculate percentages
        for (const row of calculatedData) {
            row.conversion_rate = (row.enrolled_form_fills / row.new_form_fills) * 100 || 0;
            row.expiration_rate =
                ((row.enrolled_form_fills + row.rejected_form_fills) / row.new_form_fills) * 100 ||
                0;
        }

        calculatedData.sort(
            (a, b) => new Date(a.week_start).getTime() - new Date(b.week_start).getTime()
        );

        setProcessedData(calculatedData);
    }, [data, state]);

    return processedData || undefined;
};

export default useGetFormFillCloseRate;
